import { Context } from '../aggregates';
import { OneSignal } from './OneSignal';
import { AuthState } from '../model/AuthenticationInfo';
import { FluxType } from '../flux/buildFlux';
import { LocationService } from './LocationService'
import { AppAnalytics } from './AppAnalytics';
import { Keyboard } from './Device';
import { BackButton } from './BackButton';
import { Observable } from 'rxjs';

import {
  permissions$,
  requestLocationBackgroundPermission, requestLocationInUsePermission, askForLocationPermissionsAfterDenial,
  requestHighAccuracyLocationPermission,
} from '../cordovaPlugins/Permissions';
import { resetKeyboard, enableLongFormKeyboard, enableSimpleKeyboard } from '../cordovaPlugins/Keyboard';
import { LocationInfo } from 'src/cordovaPlugins/Location';
import { PushMessageHandler } from './PushMessageHandler';
import { WlService, AppServices } from './Service';
import { isCordova } from 'utils/platform';

abstract class ServicesWithLocation extends WlService {
  protected getLocation: () => Promise<LocationInfo>;

  constructor(
    protected authState$: Observable<AuthState>,
    protected flux: FluxType,
    protected aggregates$: Observable<Context>) {
    super(authState$, flux, aggregates$);
    const { lastLocation$, getLocation } = this.start('LocationService', LocationService);
    this.location$ = lastLocation$;
    this.getLocation = getLocation;
  }

}

export class Services extends ServicesWithLocation {
  build(): AppServices {

    this.start('BackButton', BackButton);
    this.start('Keyboard', Keyboard);
    if (isCordova()) {
      this.start('AppAnalytics', AppAnalytics);
    }

    const oneSignalService = this.start('OneSignal', OneSignal);
    const { startPush, pushEvents$ } = this.start('PushMessageHandler', PushMessageHandler, { oneSignalService });

    return {
      permissions$,
      pushEvents$,
      location$: this.location$,
      locationFunctions: {
        getLocation: this.getLocation,
      },
      permissionFunctions: {
        startPush,
        requestLocationBackgroundPermission,
        requestLocationInUsePermission,
        requestHighAccuracyLocationPermission,
        askForLocationPermissionsAfterDenial,
      },
      keyboard: {
        resetKeyboard, useLongFormKeyboard: enableLongFormKeyboard, useSimpleKeyboard: enableSimpleKeyboard,
      },
    };
  }
}
